import React from "react";
import { DisplayProps } from "models/propTypes/wintFormPropsTypes";
import ReadOnlyField from "../../forms/baseFields/readOnlyField";
import cssExports from "theme/styles/main.module.scss";

const TextDisplay: React.FC<DisplayProps> = (props: DisplayProps) => {
  return (
    <ReadOnlyField label={props.label} className={cssExports.readOnlyTextField} href={props.href}>
      {props.value}
    </ReadOnlyField>
  );
};

export default TextDisplay;
